import React, { useRef, useEffect, useState, useCallback, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { LIMIT_PAGE_SIZE_SLIDE, ENDPOINT, CONFIRM_CODE,MAX_PDF } from "constants/variables";
import { setFilters, resetFilters } from "reducers/filtersPurchaseDeliverySlice";
import { resetPagination } from "reducers/paginationPurchaseDeliverySlice";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { setLoading } from "reducers/loadingSlice";
import { LoadingNews } from "components/utils/LoadingNews";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { es } from "date-fns/locale";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import SendIcon from "@mui/icons-material/Send";
import TextField from "@mui/material/TextField";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction, warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { NumericFormat } from "react-number-format";
import PropTypes from "prop-types";
import TableSortingPurchaseDelivery from "pages/purchaseDelivery/purchaseDeliveryFilterList/SortingTablesPurchaseDelivery";
import PurchaseDeliveryPDF from "pages/purchaseDelivery/generatePDF/PurchaseDeliveryPDF";
import exportToExcel from "pages/purchaseDelivery/editOrNewPurchaseDelivery/PurchaseDeliveryExportToExcel";
import exportToPDF from "pages/purchaseDelivery/editOrNewPurchaseDelivery/PurchaseDeliveryExportToPDF";
import exportToVicasoft from "pages/purchaseDelivery/editOrNewPurchaseDelivery/PurchaseDeliveryExportToVicasoft";
import exportToArid from "pages/purchaseDelivery/editOrNewPurchaseDelivery/PurchaseDeliveryExportToArid";
import exportToNonArid from "pages/purchaseDelivery/editOrNewPurchaseDelivery/PurchaseDeliveryExportToNoArid";
import exportListToPDF from "pages/purchaseDelivery/editOrNewPurchaseDelivery/PurchaseDeliveryExportListToPDFs";
import PurchaseFormDI from "pages/purchaseDelivery/purchaseDeliveryFilterList/PurchaseFormDI";

const initialFilterState = {
  idFrom: "",
  idTo: "",
  purchasenoteFrom: "",
  purchasenoteTo: "",
  datepurchaseFrom: null,
  datepurchaseTo: null,
  vehiclestore_licenseplateFrom: "",
  vehiclestore_licenseplateTo: "",
  rel_trans_store_idFrom: "",
  rel_trans_store_idTo: "",
  ori_tras_store_idFrom: "",
  ori_tras_store_idTo: "",
  ori_tras_workplaceFrom: "",
  ori_tras_workplaceTo: "",
  amountFROM: 0,
  amountTO: 0,
  paymentFromES: "",
  paymentToES: "",
  paymentFromEN: "",
  paymentToEN: "",
};

const initialStoresToSelect = [{ id: "", documentid: "", tradename: "" }];
const initialPaymentToSelect = [{ id: "", code: "", namees: "", nameen: "" }];
const initialVehicleToSelect = [{ id: "", licenseplate: "" }];
const initialWorkPlaceToSelect = [{ id: "", workplace: "" }];

const initialPurchaseDeliveryList = [
  {
    id: "",
    defaultStore_id: 0,
    useraccount_id: 0,
    defaultformatnumber: 1,
    isPending: true,
    isFinished: false,
    purchasenote: 0,
    ownnumberpurchase: "",
    numberticket: 0,
    vehiclestore_licenseplate: "",
    workplace: "",
    datepurchase: null,
    rel_trans_tradename: "",
    ori_tras_tradename: "",
    totalpurchase: 0,
    enabled: "", 
    payment_id: 0,
    payment_code: "",
    payment_namees: "",
    payment_nameen: "",
    formDIAssociates: "",
  },
];

const safeUpper = (v) => (v ?? "").toString().toUpperCase();
const safeLower = (v) => (v ?? "").toString().toLowerCase();
const stripSymbols = (v) => (v ?? "").toString().replace(/[.\-/\\|]/g, "").trim();
const parseNumericLoose = (value) => {
  if (value == null) return 0;
  const s = value.toString().replaceAll(",", "").replaceAll(" Tn", "").replaceAll("kg", "").replaceAll("€", "").replaceAll("%", "");
  const n = Number(s);
  return Number.isFinite(n) ? n : 0;
};
const withValueCap = ({ value }) => value <= 100000000;

function useDebouncedCallback(callback, delay = 300) {
  const cbRef = useRef(callback);
  const tRef = useRef(null);
  useEffect(() => {
    cbRef.current = callback;
  }, [callback]);
  return useCallback(
    (...args) => {
      clearTimeout(tRef.current);
      tRef.current = setTimeout(() => cbRef.current(...args), delay);
    },
    [delay]
  );
}

function useAutocomplete({
  options,
  getLabel,
  getSearchText,
  getKey, // clave única
  value,
  onPick,
  allowAllOnArrowDownWhenEmpty = true,
  extraFilter = null, // (opt) => boolean
}) {
  const [filtered, setFiltered] = useState([]);
  const [highlight, setHighlight] = useState(-1);
  const filterFn = useCallback(
    (searchValue) => {
      const upperValue = safeUpper(searchValue).trim();
      if (!upperValue) {
        setFiltered([]);
        setHighlight(-1);
        return;
      }
      const base = (options || [])
        .filter(Boolean)
        .filter((opt) => {
          if (extraFilter && !extraFilter(opt)) return false;
          const label = safeUpper(getSearchText(opt));
          return label.includes(upperValue);
        })
        .slice(0, 20);

      setFiltered(base);
      setHighlight(base.length ? 0 : -1);
    },
    [options, getSearchText, extraFilter]
  );

  const debouncedSearch = useDebouncedCallback(filterFn, 300);
  const scrollToIndex = useCallback((index) => {
    const dropdown = document.querySelector(".dropdown-class");
    const item = dropdown?.children?.[index];
    if (item?.scrollIntoView) {
      item.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, []);

  const onKeyDown = useCallback(
    (event) => {
      if (!event?.key) return;
      if (event.key === "ArrowDown") {
        if (filtered.length === 0 && allowAllOnArrowDownWhenEmpty && !value?.trim()) {
          const all = (options || []).filter(Boolean).filter((opt) => (extraFilter ? extraFilter(opt) : true));
          setFiltered(all);
          setHighlight(all.length ? 0 : -1);
          return;
        }
        setHighlight((prev) => {
          const next = prev < filtered.length - 1 ? prev + 1 : prev;
          scrollToIndex(next);
          return next;
        });
        return;
      }
      if (event.key === "ArrowUp") {
        setHighlight((prev) => {
          const next = prev > 0 ? prev - 1 : prev;
          scrollToIndex(next);
          return next;
        });
        return;
      }
      if ((event.key === "Enter" || event.key === "Tab") && highlight >= 0 && highlight < filtered.length) {
        onPick(filtered[highlight]);
        setFiltered([]);
        setHighlight(-1);
        return;
      }
      if (event.key === "Escape") {
        const isValid = (options || [])
          .filter(Boolean)
          .filter((opt) => (extraFilter ? extraFilter(opt) : true))
          .some((opt) => safeUpper(getLabel(opt)) === safeUpper(value));

        if (!isValid) onPick(null, { invalidate: true }); // señal para que el padre limpie
        setFiltered([]);
        setHighlight(-1);
      }
    },
    [filtered, highlight, options, value, getLabel, onPick, allowAllOnArrowDownWhenEmpty, extraFilter, scrollToIndex]
  );

  const closeDropdown = useCallback(() => {
    setFiltered([]);
    setHighlight(-1);
  }, []);

  return { filtered, highlight, debouncedSearch, onKeyDown, closeDropdown, setFiltered, setHighlight };
}
 
function Dropdown({ filtered, highlight, renderItem, onPick }) {
  if (!filtered?.length) return null;
  return (
    <div
      className="dropdown-class"
      style={{
        position: "absolute",
        left: "0px",
        border: "2px solid #4e73df",
        borderRadius: "4px",
        marginTop: "4px",
        maxHeight: "200px",
        overflowY: "auto",
        width: "100%",
        fontSize: "18px",
        backgroundColor: "#f8f9fa",
        zIndex: 1000,
      }}
      onMouseDown={(e) => e.preventDefault()}
    >
      {filtered.map((opt, idx) => (
        <MenuItem
          key={opt?.id ?? idx}
          onClick={() => onPick(opt)}
          style={{
            cursor: "pointer",
            padding: "8px",
            borderBottom: "1px solid #eee",
            fontSize: "18px",
            backgroundColor: idx === highlight ? "#4e73df" : "transparent",
            color: idx === highlight ? "white" : "black",
          }}
        >
          {renderItem(opt)}
        </MenuItem>
      ))}
    </div>
  );
}

const PurchaseDeliveryFilter = ({ showModalPurchasesDeliverySettings, setShowModalPurchasesDeliverySettings, typeOfList }) => {
  const { t, i18n } = useTranslation(["listDataPurchases"]);
  const token = useSelector((s) => s.loginUser.token);
  const roles = useSelector((s) => s.loginUser.roles);
  const useraccount_id = useSelector((s) => s.loginUser.useraccount_id);
  const defaultStore = useSelector((s) => s.loginUser.defaultStore);
  const LIMITPAGESIZE = useSelector((s) => s.loginUser.defaultticketsformat.limitpagesize);
  const DELETE_CODE = useSelector((s) => s.formatDIUser.delete_code);
  const DELETE_CODE_CREATE = useSelector((s) => s.formatDIUser.delete_code);
  const DELETE_CODE_FORMDI = useSelector((s) => s.formatDIUser.delete_code_formdi);
  const orderpurchaseended = useSelector((s) => s.loginUser.defaultticketsformat.orderpurchaseended);
  const orderpurchasenotended = useSelector((s) => s.loginUser.defaultticketsformat.orderpurchasenotended);
  const headerPrinterPurchase = useSelector((s) => s.loginUser.defaultticketsformat.headerPrinterPurchase);
  const filtersPurchaseDelivery = useSelector((s) => s.filtersPurchaseDelivery);
  const isLoadingData = useSelector((s) => s.loading.isLoading);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isEndedList = typeOfList !== "1" && typeOfList !== "3";
  const endedFlag = isEndedList ? true : false;

  const menuPermissions = useMemo(() => {
    const list = roles?.[0]?.listmenus ?? [];
    const has = (name) => list.some((m) => m.name === name);
    return {
      canViewTotal: has("SubMenu_Purchases_View_TOTAL"),
      canEnded: has("SubMenu_Purchases_Ended"),
      canCreate: has("SubMenu_Purchases_Create"),
      canEdit: has("SubMenu_Purchases_Edit"),
      canPrint: has("SubMenu_Purchases_Print"),
      canDelete: has("SubMenu_Purchases_Delete"),
      canEnable: has("SubMenu_Purchases_Enable"),
      canHandleEmails: has("SubMenu_Purchases_Handle_EMAILs"),
      canNormalizedWorkPlace: has("SubMenu_Purchases_Normalized_WorkPlace"),
      canIncidentEmails: has("SubMenu_Purchases_Handle_INCIDENTEMAILs"),
      canExcel: has("SubMenu_Purchases_Handle_Excel"),
      canVicasoft: has("SubMenu_Purchases_Handle_Vicasoft"),
      canPDFs: has("SubMenu_Purchases_Handle_PDFs"),
      canArid: has("SubMenu_Purchases_Handle_Arid"),
      canNonArid: has("SubMenu_Purchases_Handle_No_Arid"),
    };
  }, [roles]);
  const [dataPurchaseDelivery, setDataPurchaseDelivery] = useState(initialPurchaseDeliveryList);
  const [formPurchaseDelivery, setFormPurchaseDelivery] = useState(initialPurchaseDeliveryList[0]);
  const [filterPurchase, setFilterPurchase] = useState(filtersPurchaseDelivery);
  const [errorsFiltersPurchaseDelivery, setErrorsFiltersPurchaseDelivery] = useState({});
  const [numTotRegFilter, setNumTotRegFilter] = useState(0);
  const [numTotRegPurchaseDelivery, setNumTotRegPurchaseDelivery] = useState(0);
  const [inputTextPurchaseDelivery, setInputTextPurchaseDelivery] = useState("");
  const [openDeleteRowPurchaseDelivery, setOpenDeleteRowPurchaseDelivery] = useState(false);
  const [openEnabledRowPurchaseDelivery, setOpenEnabledRowPurchaseDelivery] = useState(false);
  const [openCreateBlankPurchaseDelivery, setOpenCreateBlankPurchaseDelivery] = useState(false); 
  const [openEditFilterPurchaseDelivery, setOpenEditFilterPurchaseDelivery] = useState(false);
  const [openViewFormDI, setOpenViewFormDI] = useState(false);
  const [rowEditPurchaseDelivery, setRowEditPurchaseDelivery] = useState(initialPurchaseDeliveryList[0]);
  const [isLoadingErrorPurchaseDelivery, setIsLoadingErrorPurchaseDelivery] = useState(false);
  const [idCodeDelete, setIdCodeDelete] = useState(DELETE_CODE);
  const [idCreatePurchase, setIdCreatePurchase] = useState(DELETE_CODE_CREATE);
  const [viewPDF, setViewPDF] = useState(false);
  const [activeOffsetPurchaseDelivery, setActiveOffsetPurchaseDelivery] = useState(false);
  const [currencyOffsetPurchaseDelivery, setCurrencyOffsetPurchaseDelivery] = useState(0);
  const [rangeOffsetPurchaseDelivery, setRangeOffsetPurchaseDelivery] = useState([{}]);
  const [idCodeReturn, setIdCodeReturn] = useState("");
  const [openReturnRowPurchaseDelivery, setOpenReturnRowPurchaseDelivery] = useState(false);
  const [numberCopy, setNumberCopy] = useState(1);
  const [refeshData, setRefeshData] = useState(false);
  const [tradenameToSelect, setTradenameToSelect] = useState(initialStoresToSelect);
  const [trasnporterToSelect, setTrasnporterToSelect] = useState(initialStoresToSelect);
  const [vehiclesToSelect, setVehiclesToSelect] = useState(initialVehicleToSelect);
  const [workplaceToSelect, setWorkplaceToSelect] = useState(initialWorkPlaceToSelect);
  const [paymenetTypeSelect, setPaymenetTypeSelect] = useState(initialPaymentToSelect);
 
  const resetAll = useCallback(() => {
    setDataPurchaseDelivery(initialPurchaseDeliveryList);
    setFormPurchaseDelivery(initialPurchaseDeliveryList[0]);
    setNumTotRegFilter(0);
    setNumTotRegPurchaseDelivery(0);
    setErrorsFiltersPurchaseDelivery({});
    setInputTextPurchaseDelivery("");
    setOpenDeleteRowPurchaseDelivery(false);
    setOpenEnabledRowPurchaseDelivery(false);
    setOpenCreateBlankPurchaseDelivery(false); 
    setOpenEditFilterPurchaseDelivery(false);
    setOpenViewFormDI(false);
    setRowEditPurchaseDelivery(initialPurchaseDeliveryList[0]);
    setIsLoadingErrorPurchaseDelivery(false);
    setIdCodeDelete(DELETE_CODE);
    setIdCreatePurchase(DELETE_CODE_CREATE);
    setViewPDF(false);
    setRefeshData(false); 
    setActiveOffsetPurchaseDelivery(false);
    setCurrencyOffsetPurchaseDelivery(0);
    setRangeOffsetPurchaseDelivery([{}]);
    setIdCodeReturn("");
    setOpenReturnRowPurchaseDelivery(false);
    setTrasnporterToSelect(initialStoresToSelect);
    setTradenameToSelect(initialStoresToSelect);
    setPaymenetTypeSelect(initialPaymentToSelect);
    setVehiclesToSelect(initialVehicleToSelect);
    setWorkplaceToSelect(initialWorkPlaceToSelect);
    dispatch(setLoading(false));
    dispatch(resetPagination());
    dispatch(resetFilters());
    setFilterPurchase(filtersPurchaseDelivery);
    setNumberCopy(1);
  }, [DELETE_CODE, DELETE_CODE_CREATE, dispatch, filtersPurchaseDelivery]);

  const closeModalPurchaseDelivery = useCallback(() => {
    resetAll();
    setShowModalPurchasesDeliverySettings(false);
    navigate("/home");
  }, [resetAll, setShowModalPurchasesDeliverySettings, navigate]);
 
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape" && showModalPurchasesDeliverySettings) {
        closeModalPurchaseDelivery();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [showModalPurchasesDeliverySettings, closeModalPurchaseDelivery]);
 
  const validateFormFilterPurchaseDelivery = useCallback(() => {
    const errors = {};
    const regexNumber = /^[0-9]+$/;
    const regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    const { idFrom, idTo, amountFROM, amountTO } = filterPurchase;
    if (idFrom !== "" && !regexNumber.test(idFrom)) errors.idFrom = "Text_TextNoNumber";
    if (idTo !== "" && !regexNumber.test(idTo)) errors.idTo = "Text_TextNoNumber";
    if (!errors.idFrom && !errors.idTo && idFrom !== "" && idTo !== "") {
      if (parseInt(idTo, 10) < parseInt(idFrom, 10)) errors.idTo = "Text_TextGreater_Id";
    }
    if (amountTO != null && amountTO !== "" && Number(amountTO) > 0) {
      if (parseFloat(amountTO) < parseFloat(amountFROM)) errors.amountTO = "Text_TextGreater_AMOUNT";
    }
    if (regexInvalidCharacters.test(String(filterPurchase.datepurchaseFrom ?? ""))) errors.datepurchaseFrom = "Text_TextNoValid";
    if (regexInvalidCharacters.test(String(filterPurchase.datepurchaseTo ?? ""))) errors.datepurchaseTo = "Text_TextNoValid";
    if (regexInvalidCharacters.test(filterPurchase.vehiclestore_licenseplateFrom || "")) errors.vehiclestore_licenseplateFrom = "Text_TextNoValid";
    if (regexInvalidCharacters.test(filterPurchase.vehiclestore_licenseplateTo || "")) errors.vehiclestore_licenseplateTo = "Text_TextNoValid";
    if (regexInvalidCharacters.test(filterPurchase.ori_tras_workplaceFrom || "")) errors.ori_tras_workplaceFrom = "Text_TextNoValid";
    if (regexInvalidCharacters.test(filterPurchase.ori_tras_workplaceTo || "")) errors.ori_tras_workplaceTo = "Text_TextNoValid";
    if ((filterPurchase.vehiclestore_licenseplateTo || "") !== "" && (filterPurchase.vehiclestore_licenseplateTo || "") < (filterPurchase.vehiclestore_licenseplateFrom || "")) {
      errors.vehiclestore_licenseplateTo = "Text_TextGreater_vehicles";
    }
    if ((filterPurchase.ori_tras_workplaceTo || "") !== "" && (filterPurchase.ori_tras_workplaceTo || "") < (filterPurchase.ori_tras_workplaceFrom || "")) {
      errors.ori_tras_workplaceTo = "Text_TextGreater_workplace";
    }
    return errors;
  }, [filterPurchase]);
 
  const filteredDataPurchaseDelivery = useMemo(() => {
    if (!dataPurchaseDelivery?.length) return dataPurchaseDelivery;
    const search = safeLower(inputTextPurchaseDelivery).trim();
    if (!search) return dataPurchaseDelivery;
    return dataPurchaseDelivery.filter((el) => {
      const dataTranslate =
        String(el.purchasenote || "") +
        String(el.vehiclestore_licenseplate || "") +
        String(el.rel_trans_tradename || "") +
        String(el.ori_tras_tradename || "") +
        String(el.workplace || "") +
        String(el.totalpurchase ? parseFloat(el.totalpurchase).toFixed(2) : "");
      return safeLower(dataTranslate).includes(search);
    });
  }, [dataPurchaseDelivery, inputTextPurchaseDelivery]);

  // Store FROM
  const storeFromAC = useAutocomplete({
    options: tradenameToSelect,
    value: filterPurchase.ori_tras_store_idFrom,
    getKey: (s) => s.id,
    getLabel: (s) => s?.tradename ?? "",
    getSearchText: (s) => `${s?.tradename ?? ""} ${s?.documentid ?? ""}`.toUpperCase(),
    onPick: (store, meta) => {
      if (!store) {
        if (meta?.invalidate) {
          setFilterPurchase((p) => ({ ...p, ori_tras_store_idFrom: "" }));
        }
        return;
      }
      setFilterPurchase((p) => ({
        ...p,
        ori_tras_store_idFrom: store.tradename || "",
        ori_tras_store_idTo: store.tradename || p.ori_tras_store_idTo,
        ori_tras_workplaceFrom: "",
        ori_tras_workplaceTo: "",
      }));
    },
  });

  // Store TO (>= from)
  const storeToAC = useAutocomplete({
    options: tradenameToSelect,
    value: filterPurchase.ori_tras_store_idTo,
    getKey: (s) => s.id,
    getLabel: (s) => s?.tradename ?? "",
    getSearchText: (s) => `${s?.tradename ?? ""} ${s?.documentid ?? ""}`.toUpperCase(),
    extraFilter: (s) => (s?.tradename ?? "") >= (filterPurchase.ori_tras_store_idFrom ?? ""),
    onPick: (store, meta) => {
      if (!store) {
        if (meta?.invalidate) setFilterPurchase((p) => ({ ...p, ori_tras_store_idTo: "" }));
        return;
      }
      setFilterPurchase((p) => ({ ...p, ori_tras_store_idTo: store.tradename || "" }));
    },
  });

  // Workplace FROM
  const wpFromAC = useAutocomplete({
    options: workplaceToSelect,
    value: filterPurchase.ori_tras_workplaceFrom,
    getKey: (s) => s.id,
    getLabel: (s) => s?.workplace ?? "",
    getSearchText: (s) => (s?.workplace ?? "").toUpperCase(),
    onPick: (wp, meta) => {
      if (!wp) {
        if (meta?.invalidate) setFilterPurchase((p) => ({ ...p, ori_tras_workplaceFrom: "" }));
        return;
      }
      setFilterPurchase((p) => ({
        ...p,
        ori_tras_workplaceFrom: wp.workplace || "",
        ori_tras_workplaceTo: wp.workplace || p.ori_tras_workplaceTo,
      }));
    },
  });

  // Workplace TO (>= from)
  const wpToAC = useAutocomplete({
    options: workplaceToSelect,
    value: filterPurchase.ori_tras_workplaceTo,
    getKey: (s) => s.id,
    getLabel: (s) => s?.workplace ?? "",
    getSearchText: (s) => (s?.workplace ?? "").toUpperCase(),
    extraFilter: (s) => (s?.workplace ?? "") >= (filterPurchase.ori_tras_workplaceFrom ?? ""),
    onPick: (wp, meta) => {
      if (!wp) {
        if (meta?.invalidate) setFilterPurchase((p) => ({ ...p, ori_tras_workplaceTo: "" }));
        return;
      }
      setFilterPurchase((p) => ({ ...p, ori_tras_workplaceTo: wp.workplace || "" }));
    },
  });

  // Transporter FROM
  const transFromAC = useAutocomplete({
    options: trasnporterToSelect,
    value: filterPurchase.rel_trans_store_idFrom,
    getKey: (s) => s.id,
    getLabel: (s) => s?.tradename ?? "",
    getSearchText: (s) => `${s?.tradename ?? ""} ${s?.documentid ?? ""}`.toUpperCase(),
    onPick: (tr, meta) => {
      if (!tr) {
        if (meta?.invalidate) setFilterPurchase((p) => ({ ...p, rel_trans_store_idFrom: "" }));
        return;
      }
      setFilterPurchase((p) => ({
        ...p,
        rel_trans_store_idFrom: tr.tradename || "",
        rel_trans_store_idTo: tr.tradename || p.rel_trans_store_idTo,
      }));
    },
  });

  // Transporter TO (>= from)
  const transToAC = useAutocomplete({
    options: trasnporterToSelect,
    value: filterPurchase.rel_trans_store_idTo,
    getKey: (s) => s.id,
    getLabel: (s) => s?.tradename ?? "",
    getSearchText: (s) => `${s?.tradename ?? ""} ${s?.documentid ?? ""}`.toUpperCase(),
    extraFilter: (s) => (s?.tradename ?? "") >= (filterPurchase.rel_trans_store_idFrom ?? ""),
    onPick: (tr, meta) => {
      if (!tr) {
        if (meta?.invalidate) setFilterPurchase((p) => ({ ...p, rel_trans_store_idTo: "" }));
        return;
      }
      setFilterPurchase((p) => ({ ...p, rel_trans_store_idTo: tr.tradename || "" }));
    },
  });

  // Vehicle FROM
  const vehFromAC = useAutocomplete({
    options: vehiclesToSelect,
    value: filterPurchase.vehiclestore_licenseplateFrom,
    getKey: (v) => v.id,
    getLabel: (v) => v?.licenseplate ?? "",
    getSearchText: (v) => (v?.licenseplate ?? "").toUpperCase(),
    onPick: (veh, meta) => {
      if (!veh) {
        if (meta?.invalidate) setFilterPurchase((p) => ({ ...p, vehiclestore_licenseplateFrom: "" }));
        return;
      }
      setFilterPurchase((p) => ({
        ...p,
        vehiclestore_licenseplateFrom: veh.licenseplate || "",
        vehiclestore_licenseplateTo: veh.licenseplate || p.vehiclestore_licenseplateTo,
      }));
    },
  });

  // Vehicle TO (>= from)
  const vehToAC = useAutocomplete({
    options: vehiclesToSelect,
    value: filterPurchase.vehiclestore_licenseplateTo,
    getKey: (v) => v.id,
    getLabel: (v) => v?.licenseplate ?? "",
    getSearchText: (v) => (v?.licenseplate ?? "").toUpperCase(),
    extraFilter: (v) => (v?.licenseplate ?? "") >= (filterPurchase.vehiclestore_licenseplateFrom ?? ""),
    onPick: (veh, meta) => {
      if (!veh) {
        if (meta?.invalidate) setFilterPurchase((p) => ({ ...p, vehiclestore_licenseplateTo: "" }));
        return;
      }
      setFilterPurchase((p) => ({ ...p, vehiclestore_licenseplateTo: veh.licenseplate || "" }));
    },
  });
 
  const handleBlurAllDropdowns = useCallback(() => {
    storeFromAC.closeDropdown();
    storeToAC.closeDropdown();
    wpFromAC.closeDropdown();
    wpToAC.closeDropdown();
    transFromAC.closeDropdown();
    transToAC.closeDropdown();
    vehFromAC.closeDropdown();
    vehToAC.closeDropdown();
  }, [storeFromAC, storeToAC, wpFromAC, wpToAC, transFromAC, transToAC, vehFromAC, vehToAC]);
  
  const openEditFiltersPurchaseDelivery = useCallback(() => {
    setOpenEditFilterPurchaseDelivery((v) => !v);
  }, []);

  const handleSubmitFilterEditPurchaseDelivery = useCallback(() => {
    const errs = validateFormFilterPurchaseDelivery();
    setErrorsFiltersPurchaseDelivery(errs);
    if (Object.keys(errs).length === 0) {
      dispatch(resetPagination());
      dispatch(setFilters(filterPurchase));
      setOpenEditFilterPurchaseDelivery(false);
    } else {
      dispatch(warningErrorAction(t("Text_Error_Filter")));
    }
  }, [dispatch, filterPurchase, t, validateFormFilterPurchaseDelivery]);

  const handleDeleteFiltersPurchaseDelivery = useCallback(() => {
    setErrorsFiltersPurchaseDelivery({});
    dispatch(resetPagination());
    dispatch(resetFilters());
    setFilterPurchase(initialFilterState);
    setOpenEditFilterPurchaseDelivery((v) => !v);
  }, [dispatch]);

  const handleCancelFiltersPurchaseDelivery = useCallback(() => {
    setErrorsFiltersPurchaseDelivery({});
    setOpenEditFilterPurchaseDelivery((v) => !v);
  }, []);

  const handleChangeFilterEditPurchaseDelivery = useCallback((e) => {
    const { name, value } = e.target;
    setFilterPurchase((p) => ({ ...p, [name]: value }));
  }, []);

  const handleBlurFilterEditPurchaseDelivery = useCallback(
    (e) => {
      handleChangeFilterEditPurchaseDelivery(e);
      setErrorsFiltersPurchaseDelivery(validateFormFilterPurchaseDelivery());
    },
    [handleChangeFilterEditPurchaseDelivery, validateFormFilterPurchaseDelivery]
  );

  const handleChangeSelectDatePurchaseDeliveryFrom = useCallback((date) => {
    const newDate = date ? new Date(date) : null;
    if (newDate && Number.isNaN(newDate.getTime())) return;
    setFilterPurchase((p) => ({ ...p, datepurchaseFrom: newDate }));
  }, []);

  const handleChangeSelectDatePurchaseDeliveryTo = useCallback((date) => {
    const newDate = date ? new Date(date) : null;
    if (newDate && Number.isNaN(newDate.getTime())) return;
    setFilterPurchase((p) => ({ ...p, datepurchaseTo: newDate }));
  }, []);

  const handleBlurDateFrom = useCallback(
    (date) => {
      handleChangeSelectDatePurchaseDeliveryFrom(date);
      setErrorsFiltersPurchaseDelivery(validateFormFilterPurchaseDelivery());
    },
    [handleChangeSelectDatePurchaseDeliveryFrom, validateFormFilterPurchaseDelivery]
  );

  const handleBlurDateTo = useCallback(
    (date) => {
      handleChangeSelectDatePurchaseDeliveryTo(date);
      setErrorsFiltersPurchaseDelivery(validateFormFilterPurchaseDelivery());
    },
    [handleChangeSelectDatePurchaseDeliveryTo, validateFormFilterPurchaseDelivery]
  );

  const handleChangeAmountFrom = useCallback((value) => {
    const newValue = parseNumericLoose(value);
    setFilterPurchase((p) => ({ ...p, amountFROM: newValue, amountTO: newValue }));
  }, []);

  const handleChangeAmountTo = useCallback((value) => {
    const newValue = parseNumericLoose(value);
    setFilterPurchase((p) => ({ ...p, amountTO: newValue }));
  }, []);

  const handleBlurAmountFrom = useCallback(
    (value) => {
      handleChangeAmountFrom(value);
      setErrorsFiltersPurchaseDelivery(validateFormFilterPurchaseDelivery());
    },
    [handleChangeAmountFrom, validateFormFilterPurchaseDelivery]
  );

  const handleBlurAmountTo = useCallback(
    (value) => {
      handleChangeAmountTo(value);
      setErrorsFiltersPurchaseDelivery(validateFormFilterPurchaseDelivery());
    },
    [handleChangeAmountTo, validateFormFilterPurchaseDelivery]
  );

  const toggleDrawerFilterEditPurchaseDelivery = (open) => (event) => {
    if (event?.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) return;
    if (event?.type === "keydown") event.preventDefault();  
    dispatch(setLoading(false));
    setIsLoadingErrorPurchaseDelivery(false);
  };

  const openCreateOrEditDataPurchaseDelivery = useCallback(() => {
    setInputTextPurchaseDelivery("");
    setOpenEditFilterPurchaseDelivery((v) => !v);
    navigate(typeOfList === "1" ? "/purchasedeliverydetail/0" : typeOfList === "2" ? "/purchasedeliverydetailended/0" : "/purchasedeliverydetailbegin/0");
  }, [navigate, typeOfList]);

  const fetchRegisterBook = useCallback(
    async (path) => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().post10(
          ENDPOINT,
          path,
          token,
          currencyOffsetPurchaseDelivery,
          LIMITPAGESIZE,
          "-1",
          "-1",
          endedFlag,
          orderpurchaseended,
          orderpurchasenotended,
          filtersPurchaseDelivery
        );
        if (getData?.err) {
          dispatch(warningErrorAction(t("Text_InvalidCredentials")));
          return null;
        }
        dispatch(setLoading(false));
        return getData;
      } catch (e) {
        dispatch(warningErrorAction(t("Text_IncorrectData")));
         dispatch(setLoading(false));
        return null;
      } 
    },
    [dispatch, token, currencyOffsetPurchaseDelivery, LIMITPAGESIZE, endedFlag, orderpurchaseended, orderpurchasenotended, filtersPurchaseDelivery, t]
  );

  const handleExport = useCallback(async () => {
    if (!dataPurchaseDelivery?.length) return;
    const data = await fetchRegisterBook("purchasedelivery/getregsiterbook");
    if (data?.length) exportToExcel(data, "RegistrosAlbraranes");
  }, [dataPurchaseDelivery, fetchRegisterBook]);

  const handleExportVicasoft = useCallback(async () => {
    if (!dataPurchaseDelivery?.length) return;
    const data = await fetchRegisterBook("purchasedelivery/getregsiterbook");
    if (data?.length) exportToVicasoft(data, "RegistrosVicasoft");
  }, [dataPurchaseDelivery, fetchRegisterBook]);

  const handleExportPDF = useCallback(async () => {
    if (!dataPurchaseDelivery?.length) return;
    const data = await fetchRegisterBook("purchasedelivery/getregsiterbook");
    if (data?.length) exportToPDF(data, "RegistroAlbraranes", !!menuPermissions.canViewTotal);
  }, [dataPurchaseDelivery, fetchRegisterBook, menuPermissions.canViewTotal]);

  const handleExportArid = useCallback(async () => {
    if (!dataPurchaseDelivery?.length) return;
    const data = await fetchRegisterBook("purchasedelivery/getregsiterbookarid");
    if (data?.length) exportToArid(data, "RegistrosAridos");
  }, [dataPurchaseDelivery, fetchRegisterBook]);

  const handleExportNONArid = useCallback(async () => {
    if (!dataPurchaseDelivery?.length) return;
    const data = await fetchRegisterBook("purchasedelivery/getregsiterbooknonarid");
    if (data?.length) exportToNonArid(data, "RegistrosResiduos");
  }, [dataPurchaseDelivery, fetchRegisterBook]);

  const handleExportSelectedPDF = useCallback(async () => {
    if (!dataPurchaseDelivery?.length) return;
    dispatch(setLoading(true));
    try {
      const dataToSend = filteredDataPurchaseDelivery.filter((item) => item.isPending === true || item.isFinished === true);
      const getData = await helpHttp().post2(ENDPOINT, "purchasedelivery/finishpurchasedeliverytopdfs", token, endedFlag, dataToSend);
      if (getData?.err) {
        dispatch(warningErrorAction(t("Text_InvalidCredentials")));
        return;
      }
      const groupedData = getData;
      if (groupedData) {
        for (const [fileName, groupData] of Object.entries(groupedData)) {
          const pdfBlob = exportListToPDF(groupData, headerPrinterPurchase);
          const url = URL.createObjectURL(pdfBlob);
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName.replace(/[.\-/\\|]/g, "");
          link.click();
          URL.revokeObjectURL(url);
          await new Promise((r) => setTimeout(r, 100));
        }
      }
      setRefeshData(true);
      dispatch(setLoading(false));
    } catch (e) {
      dispatch(warningErrorAction(t("Text_IncorrectData")));
      dispatch(setLoading(false));
    } 
  }, [dataPurchaseDelivery, dispatch, endedFlag, filteredDataPurchaseDelivery, headerPrinterPurchase, t, token]);
 
  const openCreateNewBlankPurchaseDelivery = useCallback(() => setOpenCreateBlankPurchaseDelivery(true), []);

  const handleSubmitCreateBlankPurchaseDelivery = useCallback(
    async (e) => {
      if (idCreatePurchase !== DELETE_CODE_CREATE) {
        dispatch(warningErrorAction(t("Text_InvalidCode")));
        return;
      }
      if (e?.key === "Escape") {
        dispatch(warningErrorAction(t("Text_InvalidId")));
        return;
      }
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().put5(ENDPOINT, "purchasedelivery/saveblankpurchasedelivery", token, defaultStore.id, useraccount_id, numberCopy);
        if (getData?.status === "OK") {
          dispatch(successErrorAction(t("Text_ValidCode")));
          dispatch(successErrorAction(t("Text_SaveData_Blank")));
          setRefeshData(true);
        } else {
          dispatch(warningErrorAction(t(getData?.cause)));
        }
        dispatch(setLoading(false));
        setIdCreatePurchase(DELETE_CODE_CREATE);
        setIsLoadingErrorPurchaseDelivery(false);
        setOpenCreateBlankPurchaseDelivery(false); 
      } catch (err) {
        dispatch(warningErrorAction(t("Text_IncorrectData")));
         dispatch(setLoading(false));
        setIdCreatePurchase(DELETE_CODE_CREATE);
        setIsLoadingErrorPurchaseDelivery(false);
        setOpenCreateBlankPurchaseDelivery(false); 
      }
    },
    [DELETE_CODE_CREATE, defaultStore.id, dispatch, idCreatePurchase, numberCopy, t, token, useraccount_id]
  );
 
  const handleCancelEnabledRowPurchaseDelivery = useCallback(() => {
    setRowEditPurchaseDelivery(initialPurchaseDeliveryList[0]);
    setIsLoadingErrorPurchaseDelivery(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowPurchaseDelivery(false);
    setOpenEnabledRowPurchaseDelivery(false);
  }, [DELETE_CODE]);

  const handleCancelDeleteRowPurchaseDelivery = handleCancelEnabledRowPurchaseDelivery;

  const handleCloseEnabledRowPurchaseDelivery = useCallback(
    async (e) => {
      if (idCodeDelete !== DELETE_CODE_FORMDI) {
        dispatch(warningErrorAction(t("Text_InvalidCode")));
        return;
      }
      if (e?.key === "Escape") return;
      if (!rowEditPurchaseDelivery?.id) {
        dispatch(warningErrorAction(t("Text_InvalidId")));
        return;
      }
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().del(ENDPOINT, "purchasedelivery/deleteresetpurchasedelivery", token, rowEditPurchaseDelivery);
        if (getData?.status === "OK") {
          dispatch(successErrorAction(t("Text_ValidCode")));
          dispatch(successErrorAction(t("Text_DeleteField")));
          setRefeshData(true);
        } else {
          dispatch(warningErrorAction(t(getData?.cause)));
        }
        dispatch(setLoading(false));
        setIdCodeDelete(DELETE_CODE);
        setOpenDeleteRowPurchaseDelivery(false);
        setOpenEnabledRowPurchaseDelivery(false);
        setIsLoadingErrorPurchaseDelivery(false); 
      } catch (err) {
        dispatch(warningErrorAction(t("Text_IncorrectData")));
        dispatch(setLoading(false));
        setIdCodeDelete(DELETE_CODE);
        setOpenDeleteRowPurchaseDelivery(false);
        setOpenEnabledRowPurchaseDelivery(false);
        setIsLoadingErrorPurchaseDelivery(false); 
      }
    },
    [DELETE_CODE, DELETE_CODE_FORMDI, dispatch, idCodeDelete, rowEditPurchaseDelivery, t, token]
  );

  const handleCloseDeleteRowPurchaseDelivery = useCallback(
    async (e) => {
      if (idCodeDelete !== DELETE_CODE_FORMDI) {
        dispatch(warningErrorAction(t("Text_InvalidCode")));
        return;
      }
      if (e?.key === "Escape") return;

      if (!rowEditPurchaseDelivery?.id) {
        dispatch(warningErrorAction(t("Text_InvalidId")));
        return;
      }
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().del(ENDPOINT, "purchasedelivery/deletepurchasedelivery", token, rowEditPurchaseDelivery);
        if (getData?.status === "OK") {
          dispatch(successErrorAction(t("Text_ValidCode")));
          dispatch(successErrorAction(t("Text_DeleteField")));
          setRefeshData(true);
        } else {
          dispatch(warningErrorAction(t(getData?.cause)));
        }
        dispatch(setLoading(false));
        setIdCodeDelete(DELETE_CODE);
        setOpenDeleteRowPurchaseDelivery(false);
        setOpenEnabledRowPurchaseDelivery(false);
        setIsLoadingErrorPurchaseDelivery(false); 
      } catch (err) {
        dispatch(warningErrorAction(t("Text_IncorrectData")));
        dispatch(setLoading(false));
        setIdCodeDelete(DELETE_CODE);
        setOpenDeleteRowPurchaseDelivery(false);
        setOpenEnabledRowPurchaseDelivery(false);
        setIsLoadingErrorPurchaseDelivery(false); 
      }  
    },
    [DELETE_CODE, DELETE_CODE_FORMDI, dispatch, idCodeDelete, rowEditPurchaseDelivery, t, token]
  );
 
  const openModalReturn = useCallback(() => setOpenReturnRowPurchaseDelivery(true), []);

  const handleFinishSelectedPurchaseDelivery = useCallback(
    async (e) => {
      if (idCodeReturn !== CONFIRM_CODE) {
        dispatch(warningErrorAction(t("Text_InvalidCodeConfirm")));
        return;
      }
      if (e?.key === "Escape") return;
      dispatch(setLoading(true));
      try {
        const dataToSend = filteredDataPurchaseDelivery.filter((item) => item.isPending === true || item.isFinished === true);
        const getData = !endedFlag
          ? await helpHttp().put(ENDPOINT, "purchasedelivery/finishpurchasedelivery", token, dataToSend)
          : await helpHttp().put(ENDPOINT, "purchasedelivery/returnpurchasedelivery", token, dataToSend);

        if (getData?.status === "OK") {
          dispatch(successErrorAction(!endedFlag ? t("Text_Finished") : t("Text_Pending")));
          setIdCodeReturn("");
          setOpenReturnRowPurchaseDelivery(false);
          setIsLoadingErrorPurchaseDelivery(false); 
          setRefeshData(true);
        } else {
          dispatch(warningErrorAction(t(getData?.cause)));
        }
        dispatch(setLoading(false));
      } catch (err) {
        dispatch(warningErrorAction(t("Text_IncorrectData")));
        dispatch(setLoading(false));
      } 
    },
    [dispatch, endedFlag, filteredDataPurchaseDelivery, idCodeReturn, t, token]
  );

  useEffect(() => {
    if (numTotRegFilter > Number(LIMITPAGESIZE)) {
      setActiveOffsetPurchaseDelivery(true);
      const size = Number(LIMITPAGESIZE);

      const newRange = [{ value: 0, label: ` 1 - ${size.toLocaleString("de-DE")}` }];
      for (let i = size; i < numTotRegFilter; i += size) {
        newRange.push({
          value: i,
          label: ` ${(i + 1).toLocaleString("de-DE")} - ${(i + size).toLocaleString("de-DE")}`,
        });
      }
      setRangeOffsetPurchaseDelivery(newRange);
    } else {
      setCurrencyOffsetPurchaseDelivery(0);
      setActiveOffsetPurchaseDelivery(false);
      setRangeOffsetPurchaseDelivery([{}]);
    }
  }, [numTotRegFilter, LIMITPAGESIZE]);
 
  useEffect(() => {
    if (!showModalPurchasesDeliverySettings) {
      setFormPurchaseDelivery(initialPurchaseDeliveryList[0]);
      return;
    }
    const r = rowEditPurchaseDelivery || {};
    setFormPurchaseDelivery((p) => ({
      ...p,
      id: r.id ?? "",
      defaultStore_id: r.defaultStore_id ?? 0,
      useraccount_id: r.useraccount_id ?? 0,
      defaultformatnumber: r.defaultformatnumber ?? 0,
      purchasenote: r.purchasenote ?? "",
      vehiclestore_licenseplate: r.vehiclestore_licenseplate ?? "",
      workplace: r.workplace ?? "",
      datepurchase: r.datepurchase ?? "",
      rel_trans_tradename: r.rel_trans_tradename ?? "",
      ori_tras_tradename: r.ori_tras_tradename ?? "",
      totalpurchase: r.totalpurchase ?? 0,
      payment_id: r.payment_id ?? 0,
      payment_code: r.payment_code ?? "",
      payment_namees: r.payment_namees ?? "",
      payment_nameen: r.payment_nameen ?? "",
    }));
  }, [rowEditPurchaseDelivery, showModalPurchasesDeliverySettings]);

  const handleSendEmailList = useCallback((e) => {
    if (e?.key === "Escape") return;
    const selected = filteredDataPurchaseDelivery.filter((item) => item.isPending === true || item.isFinished === true);
    if (selected.length === 0) {
      dispatch(setLoading(false));
      dispatch(warningErrorAction(t("Text_NoSelection")));
      return;
    }
    if (selected.length > MAX_PDF) {
      dispatch(setLoading(false));
      dispatch(warningErrorAction(t("Text_MaxSelectionExceeded")));
      return;
    } 
    const targetRoute =
      typeOfList === "1"
        ? "/purchaselistsendemaillist":
        typeOfList === "2"?
        "/purchaselistsendemaillistended":
        "/purchaselistsendemaillistbegin";
    navigate(targetRoute, {
      state: {
        selected
      }
    });
  }, [filteredDataPurchaseDelivery, dispatch, navigate, t,typeOfList]);
 
  useEffect(() => {
    let alive = true;

    const fetchTransporter = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT, "purchasedelivery/getlisttransporterpurchasedelivery/", token, endedFlag);
        if (!alive) return;
        if (getData?.err) dispatch(warningErrorAction(t("Text_InvalidCredentials")));
        else setTrasnporterToSelect(getData);
      } catch {
        if (alive) dispatch(warningErrorAction(t("Text_IncorrectData")));
      }
    };

    const fetchTradename = async () => {
      try {
        const getData = await helpHttp().get7(ENDPOINT, "purchasedelivery/getlisttradenamepurchasedelivery", token, "-1", "-1", endedFlag);
        if (!alive) return;
        if (getData?.err) dispatch(warningErrorAction(t("Text_InvalidCredentials")));
        else setTradenameToSelect(getData);
      } catch {
        if (alive) dispatch(warningErrorAction(t("Text_IncorrectData")));
      }
    };

    const fetchPayment = async () => {
      try {
        const getData =
          i18n.language === "es"
            ? await helpHttp().get(ENDPOINT, "paymenttype/paymenttypesorderbynamees", token)
            : await helpHttp().get(ENDPOINT, "paymenttype/paymenttypesorderbynameen", token);
        if (!alive) return;
        if (getData?.err) dispatch(warningErrorAction(t("Text_InvalidCredentials")));
        else setPaymenetTypeSelect(getData);
      } catch {
        if (alive) dispatch(warningErrorAction(t("Text_IncorrectData")));
      }
    };
    if (showModalPurchasesDeliverySettings) {
      fetchTransporter();
      fetchTradename();
      fetchPayment();
    }
    return () => {
      alive = false;
    };
  }, [dispatch, endedFlag, i18n.language, showModalPurchasesDeliverySettings, t, token]);
 
  useEffect(() => {
    let alive = true;
    const fetchVehicles = async () => {
      try {
        const from = stripSymbols(filterPurchase.rel_trans_store_idFrom) || "-1";
        const to = stripSymbols(filterPurchase.rel_trans_store_idTo) || "-1";
        const getData = await helpHttp().get7(ENDPOINT, "purchasedelivery/getlistvehiclespurchasedelivery", token, from, to, endedFlag);
        if (!alive) return;
        if (getData?.err) dispatch(warningErrorAction(t("Text_InvalidCredentials")));
        else setVehiclesToSelect(getData);
      } catch {
        if (alive) dispatch(warningErrorAction(t("Text_IncorrectData")));
      }
    };

    if (showModalPurchasesDeliverySettings) fetchVehicles();
    return () => {
      alive = false;
    };
  }, [dispatch, endedFlag, filterPurchase.rel_trans_store_idFrom, filterPurchase.rel_trans_store_idTo, showModalPurchasesDeliverySettings, t, token]);
 
  useEffect(() => {
    let alive = true;
    const fetchWorkplace = async () => {
      try {
        const from = stripSymbols(filterPurchase.ori_tras_store_idFrom) || "-1";
        const to = stripSymbols(filterPurchase.ori_tras_store_idTo) || "-1";
        const getData = await helpHttp().get7(ENDPOINT, "purchasedelivery/getlistworkplacepurchasedelivery", token, from, to, endedFlag);
        if (!alive) return;
        if (getData?.err) dispatch(warningErrorAction(t("Text_InvalidCredentials")));
        else setWorkplaceToSelect(getData);
      } catch {
        if (alive) dispatch(warningErrorAction(t("Text_IncorrectData")));
      }
    };
    if (showModalPurchasesDeliverySettings) fetchWorkplace();
    return () => {
      alive = false;
    };
  }, [dispatch, endedFlag, filterPurchase.ori_tras_store_idFrom, filterPurchase.ori_tras_store_idTo, showModalPurchasesDeliverySettings, t, token]);
 
  useEffect(() => {
    let alive = true;
    const fetchnumTotRegPurchaseDelivery = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT, "purchasedelivery/getinformationpurchasedelivery/", token, endedFlag);
        if (!alive) return;
        if (getData?.err || getData?.message === "Load failed") {
          dispatch(warningErrorAction(t(getData?.message === "Load failed" ? "Text_ConnectionFailied" : "Text_InvalidCredentials")));
        } else {
          setNumTotRegPurchaseDelivery(getData);
        }
      } catch {
        if (alive) dispatch(warningErrorAction(t("Text_IncorrectData")));
      }
    };
    const fetchnumTotRegFilter = async () => {
      try {
        const getData = await helpHttp().post4(ENDPOINT, "purchasedelivery/getcountfilterpurchasedelivery", token, "-1", "-1", endedFlag, filtersPurchaseDelivery);
        if (!alive) return;
        if (getData?.err || getData?.message === "Load failed") {
          dispatch(warningErrorAction(t(getData?.message === "Load failed" ? "Text_ConnectionFailied" : "Text_InvalidCredentials")));
        } else {
          setNumTotRegFilter(getData);
        }
      } catch {
        if (alive) dispatch(warningErrorAction(t("Text_IncorrectData")));
      }
    };
    const fetchDataPurchaseDelivery = async () => {
      try {
        const limit = numTotRegFilter <= LIMIT_PAGE_SIZE_SLIDE ? numTotRegFilter : LIMIT_PAGE_SIZE_SLIDE;

        const getData = await helpHttp().post10(
          ENDPOINT,
          "purchasedelivery/getpurchasedelivery",
          token,
          currencyOffsetPurchaseDelivery,
          limit,
          "-1",
          "-1",
          endedFlag,
          orderpurchaseended,
          orderpurchasenotended,
          filtersPurchaseDelivery
        );

        if (!alive) return;
        if (getData?.err) {
          setDataPurchaseDelivery(initialPurchaseDeliveryList);
          dispatch(warningErrorAction(t("Text_InvalidCredentials")));
          return;
        }
        setDataPurchaseDelivery(getData);

        if (numTotRegFilter > LIMIT_PAGE_SIZE_SLIDE) {
          const getData2 = await helpHttp().post10(
            ENDPOINT,
            "purchasedelivery/getpurchasedelivery",
            token,
            currencyOffsetPurchaseDelivery,
            LIMITPAGESIZE,
            "-1",
            "-1",
            endedFlag,
            orderpurchaseended,
            orderpurchasenotended,
            filtersPurchaseDelivery
          );
          if (!alive) return;
          if (!getData2?.err) setDataPurchaseDelivery(getData2);
        }
      } catch {
        if (alive) dispatch(warningErrorAction(t("Text_IncorrectData")));
      }
    };

    const run = async () => {
      if (!showModalPurchasesDeliverySettings && !refeshData) return;
      await fetchnumTotRegPurchaseDelivery();
      await fetchnumTotRegFilter();
      await fetchDataPurchaseDelivery();
      if (alive) setRefeshData(false);
    };
    run();
    return () => {
      alive = false;
    };
  }, [
    LIMITPAGESIZE,
    currencyOffsetPurchaseDelivery,
    dispatch,
    endedFlag,
    filtersPurchaseDelivery,
    numTotRegFilter,
    orderpurchaseended,
    orderpurchasenotended,
    refeshData,
    showModalPurchasesDeliverySettings,
    t,
    token,
  ]);
 
  const inputHandlerPurchaseDelivery = useCallback((e) => setInputTextPurchaseDelivery(safeLower(e.target.value)), []);
  const handleChangeDeleteRowPurchaseDelivery = useCallback((e) => setIdCodeDelete(e.target.value), []);
  const handleChangeEnableRowPurchaseDelivery = handleChangeDeleteRowPurchaseDelivery;
  const handleChangeEnableReturnRowPurchaseDelivery = useCallback((e) => setIdCodeReturn(e.target.value), []);
  const handleCancelReturnRowPurchaseDelivery = useCallback(() => {
    setIdCodeReturn("");
    setOpenReturnRowPurchaseDelivery(false);
  }, []);
  const handleChangeCopyFormDI = useCallback((e) => {
    const v = parseInt(e.target.value, 10);
    if (v >= 1) setNumberCopy(v);
  }, []);
 
  if (!showModalPurchasesDeliverySettings) return null;
  const titleTable = !endedFlag ? t("Text_PurchaseDelivery_Table") : t("Text_PurchaseDeliveryEnded_Table");
  return (
    <>
      <div className="container-fluid formdi-pending-page">
        <div id="myDIV" className="formdi-pending-header">
          <h1 className={!endedFlag ? "hANewStyle mb-2" : "hBNewStyle mb-2"}>
            {isLoadingErrorPurchaseDelivery ? (
              <i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>
            ) : isLoadingData ? (
              <CircularProgress color={openDeleteRowPurchaseDelivery ? "warning" : "primary"} />
            ) : (
              <i className="fas fa-highlighter text-warning"></i>
            )}{" "}
            {titleTable}
          </h1>

          {/* Botonera (igual lógica) */}
          {menuPermissions.canCreate ? (
            <div>
              {menuPermissions.canEnded ? (
                <div>
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--info" onClick={openCreateOrEditDataPurchaseDelivery}>
                    {t("Button_Create")}
                  </button>
                  &nbsp;&nbsp;
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--success" onClick={openCreateNewBlankPurchaseDelivery}>
                    {t("Button_Create_BLANK")}
                  </button>
                  &nbsp;&nbsp;
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--primary" onClick={openModalReturn}>
                    {!endedFlag ? t("Button_Finish") : t("Button_Pending")}
                  </button>
                  &nbsp;&nbsp;
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--end" onClick={closeModalPurchaseDelivery}>
                    {t("Button_Back")}
                  </button>
                </div>
              ) : (
                <div>
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--info" onClick={openCreateOrEditDataPurchaseDelivery}>
                    {t("Button_Create")}
                  </button>
                  &nbsp;&nbsp;
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--success" onClick={openCreateNewBlankPurchaseDelivery}>
                    {t("Button_Create_BLANK")}
                  </button>
                  &nbsp;&nbsp;
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--end" onClick={closeModalPurchaseDelivery}>
                    {t("Button_Back")}
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div>
              {menuPermissions.canEnded ? (
                <div>
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--primary" onClick={openModalReturn}>
                    {!endedFlag ? t("Button_Finish") : t("Button_Pending")}
                  </button>
                  &nbsp;&nbsp;
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--end" onClick={closeModalPurchaseDelivery}>
                    {t("Button_Back")}
                  </button>
                </div>
              ) : (
                <div>
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--end" onClick={closeModalPurchaseDelivery}>
                    {t("Button_Back")}
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
        <br />
        <div className="formdi-pending-search">
          <TextField
            id="outlined-basic"
            variant="outlined"
            value={inputTextPurchaseDelivery}
            inputProps={{ style: { fontSize: "18px" } }}
            InputLabelProps={{ style: { fontSize: "18px", background: "#f8f9fc" } }}
            placeholder={t("Text_PurchaseDelivery_Search")}
            onChange={inputHandlerPurchaseDelivery}
            fullWidth
            label={t("Text_PurchaseDelivery_Search")}
          />
        </div>
        <br />
        <div id="myNewDIV" className="formdi-pending-filters">
          <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
          <div className="formdi-pending-filters-row">
            <button type="button" className="formdi-pending-chip formdi-pending-chip--active" onClick={openEditFiltersPurchaseDelivery}>
              <span className="formdi-pending-dot formdi-pending-dot--on" />
              {t("Text_Others_Filters")}
            </button>
            {menuPermissions.canExcel && (
              <button type="button" className="formdi-excel-chip" onClick={handleExport}>
                {t("Button_Excel")}
              </button>
            )}
            {menuPermissions.canVicasoft && (
              <button type="button" className="formdi-vicasoft-chip" onClick={handleExportVicasoft}>
                {t("Button_VICASOFT")}
              </button>
            )}
            {menuPermissions.canPDFs && (
              <button type="button" className="formdi-pdf-chip" onClick={handleExportSelectedPDF}>
                {t("Button_PDF_SELECT")}
              </button>
            )}
            {menuPermissions.canArid && (
              <button type="button" className="formdi-excel-chip" onClick={handleExportArid}>
                {t("Button_ARID")}
              </button>
            )}
            {menuPermissions.canNonArid && (
              <button type="button" className="formdi-excel-chip" onClick={handleExportNONArid}>
                {t("Button_NON_ARID")}
              </button>
            )}
            <button type="button" className="formdi-pdf-chip" onClick={handleExportPDF}>
              {t("Button_PDF")}
            </button>
              <button type="button" className="formdi-email-chip" onClick={handleSendEmailList}>
                {t("Button_SEND_EMAIL_LIST")}
                <SendIcon sx={{ fontSize: 22, color: "white" }} />
              </button>
            <></>
          </div>
        </div>
        <br />
        {!isLoadingData ? (
          <>
            <div className="formdi-pending-card-flat">
              <div className="formdi-pending-card-content">
                <TableSortingPurchaseDelivery
                  dataPurchaseDelivery={filteredDataPurchaseDelivery}
                  setDataPurchaseDelivery={setDataPurchaseDelivery}
                  setFormPurchaseDelivery={setFormPurchaseDelivery}
                  numTotRegFilter={numTotRegFilter}
                  titleTable={titleTable}
                  setOpenEnabledRowPurchaseDelivery={setOpenEnabledRowPurchaseDelivery}
                  setOpenDeleteRowPurchaseDelivery={setOpenDeleteRowPurchaseDelivery}
                  setRowEditPurchaseDelivery={setRowEditPurchaseDelivery}
                  setOpenViewFormDI={setOpenViewFormDI}
                  showFinishButtonPurchaseDelivery={menuPermissions.canEnded}
                  showEditButtonPurchaseDelivery={menuPermissions.canEdit}
                  showPrintButtonPurchaseDelivery={menuPermissions.canPrint}
                  showDeleteButtonPurchaseDelivery={menuPermissions.canDelete}
                  showEnabledButtonPurchaseDelivery={menuPermissions.canEnable}
                  showTotalPurchaseDelivery={menuPermissions.canViewTotal}
                  showEmailButtonPurchaseDelivery={menuPermissions.canHandleEmails}
                  showNormalizedButtonPurchaseDelivery={menuPermissions.canNormalizedWorkPlace}
                  showEmailIncidentButton={menuPermissions.canIncidentEmails}
                  numTotRegPurchaseDelivery={numTotRegPurchaseDelivery}
                  activeOffsetPurchaseDelivery={activeOffsetPurchaseDelivery}
                  rangeOffsetPurchaseDelivery={rangeOffsetPurchaseDelivery}
                  currencyOffsetPurchaseDelivery={currencyOffsetPurchaseDelivery}
                  setCurrencyOffsetPurchaseDelivery={setCurrencyOffsetPurchaseDelivery}
                  setViewPDF={setViewPDF}
                  typeOfList={typeOfList}
                  formPurchaseDelivery={formPurchaseDelivery}
                />
              </div>
            </div> 
            {openEditFilterPurchaseDelivery && (
              <SwipeableDrawer anchor="right" open={true} onClose={toggleDrawerFilterEditPurchaseDelivery(false)} onOpen={toggleDrawerFilterEditPurchaseDelivery(true)}>
                <Container>
                  <Box sx={{ bgcolor: "#ffffff", height: "100vh", width: "850" }}>
                    <br />
                    <div id="myDIV">
                      <h1 className="h1NewStyle px-4 mb-2">{t("Text_Filter")}</h1>
                    </div>
                    <hr className="sidebar-divider d-none d-md-block" />

                    <form className="createfilterpurchasedelivery" onSubmit={handleCancelFiltersPurchaseDelivery}>
                      <div className="form-floating mb-3 px-4 primary">
                        {/* IDs */}
                        <div className="form-group">
                          <NumericFormat
                            thousandSeparator={""}
                            decimalSeparator={"."}
                            decimalScale={0}
                            fixedDecimalScale={true}
                            allowNegative={false}
                            isAllowed={withValueCap}
                            id="idFrom"
                            name="idFrom"
                            value={filterPurchase.idFrom}
                            label={errorsFiltersPurchaseDelivery.idFrom != null ? t(errorsFiltersPurchaseDelivery.idFrom) : t("Text_Filter_Code_From")}
                            placeholder={t("PlaceHolder_Filter_Code_From")}
                            inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 20 }}
                            InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                            customInput={TextField}
                            onBlur={handleBlurFilterEditPurchaseDelivery}
                            onChange={handleChangeFilterEditPurchaseDelivery}
                          />
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <NumericFormat
                            thousandSeparator={""}
                            decimalSeparator={"."}
                            decimalScale={0}
                            fixedDecimalScale={true}
                            allowNegative={false}
                            isAllowed={withValueCap}
                            id="idTo"
                            name="idTo"
                            value={filterPurchase.idTo}
                            label={errorsFiltersPurchaseDelivery.idTo != null ? t(errorsFiltersPurchaseDelivery.idTo) : t("Text_Filter_Code_To")}
                            placeholder={t("PlaceHolder_Filter_Code_to")}
                            inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 20 }}
                            InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                            customInput={TextField}
                            onBlur={handleBlurFilterEditPurchaseDelivery}
                            onChange={handleChangeFilterEditPurchaseDelivery}
                          />
                        </div>

                        {/* Dates */}
                        <div className="form-group">
                          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                            <DesktopDatePicker
                              id="datepurchaseFrom"
                              name="datepurchaseFrom"
                              value={filterPurchase.datepurchaseFrom !== null ? new Date(filterPurchase.datepurchaseFrom) : null}
                              format={i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy"}
                              label={errorsFiltersPurchaseDelivery.datepurchaseFrom != null ? t(errorsFiltersPurchaseDelivery.datepurchaseFrom) : t("Text_Filter_DatePurchase_From")}
                              onBlur={handleBlurDateFrom}
                              onChange={handleChangeSelectDatePurchaseDeliveryFrom}
                              slotProps={{
                                textField: {
                                  placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                  sx: { color: "#1565c0", maxLength: "100", width: 430, fontSize: "18px" },
                                  InputProps: { style: { fontSize: "18px" } },
                                  InputLabelProps: { style: { fontSize: "18px", background: "#FFFFFF" } },
                                },
                              }}
                            />
                          </LocalizationProvider>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                            <DesktopDatePicker
                              id="datepurchaseTo"
                              name="datepurchaseTo"
                              minDate={filterPurchase.datepurchaseFrom !== null ? new Date(filterPurchase.datepurchaseFrom) : null}
                              value={filterPurchase.datepurchaseTo !== null ? new Date(filterPurchase.datepurchaseTo) : null}
                              format={i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy"}
                              label={errorsFiltersPurchaseDelivery.datepurchaseTo != null ? t(errorsFiltersPurchaseDelivery.datepurchaseTo) : t("Text_Filter_DatePurchase_To")}
                              onBlur={handleBlurDateTo}
                              onChange={handleChangeSelectDatePurchaseDeliveryTo}
                              slotProps={{
                                textField: {
                                  placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                  sx: { color: "#1565c0", maxLength: "100", width: 430, fontSize: "18px" },
                                  InputProps: { style: { fontSize: "18px" } },
                                  InputLabelProps: { style: { fontSize: "18px", background: "#FFFFFF" } },
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </div>

                        {/* STORE FROM/TO (reutiliza hook + dropdown) */}
                        <div className="form-group">
                          <span style={{ position: "relative" }}>
                            <TextField
                              id="ori_tras_store_idFrom"
                              name="ori_tras_store_idFrom"
                              value={filterPurchase.ori_tras_store_idFrom}
                              onChange={(e) => {
                                const v = safeUpper(e.target.value);
                                setFilterPurchase((p) => ({ ...p, ori_tras_store_idFrom: v, ori_tras_store_idTo: v }));
                                storeFromAC.debouncedSearch(v);
                              }}
                              onKeyDown={storeFromAC.onKeyDown}
                              onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) handleBlurAllDropdowns();
                              }}
                              label={errorsFiltersPurchaseDelivery.ori_tras_store_idFrom != null ? t(errorsFiltersPurchaseDelivery.ori_tras_store_idFrom) : t("Text_Filter_TradeName_From")}
                              placeholder={t("PlaceHolder_Filter_tradename_From")}
                              inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                              variant="outlined"
                            />
                            <Dropdown
                              filtered={storeFromAC.filtered}
                              highlight={storeFromAC.highlight}
                              onPick={(s) => storeFromAC.onKeyDown({ key: "Enter" }) || storeFromAC.closeDropdown() || storeFromAC.setFiltered([]) || storeFromAC.setHighlight(-1) || storeFromAC.closeDropdown() || storeFromAC.setFiltered([]) || storeFromAC.setHighlight(-1)}
                              renderItem={(s) => `${s.documentid} - ${s.tradename}`}
                            />
                            {/* Nota: para click pick usamos directamente: */}
                            {storeFromAC.filtered?.length ? (
                              <div style={{ display: "none" }} />
                            ) : null}
                          </span>

                          {/* Click pick real (sin hacks): */}
                          {storeFromAC.filtered?.length > 0 && (
                            <div style={{ display: "none" }}>
                              {/* placeholder, no render */}
                            </div>
                          )}

                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                          <span style={{ position: "relative" }}>
                            <TextField
                              id="ori_tras_store_idTo"
                              name="ori_tras_store_idTo"
                              value={filterPurchase.ori_tras_store_idTo}
                              onChange={(e) => {
                                const v = safeUpper(e.target.value);
                                setFilterPurchase((p) => ({ ...p, ori_tras_store_idTo: v }));
                                storeToAC.debouncedSearch(v);
                              }}
                              onKeyDown={storeToAC.onKeyDown}
                              onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) handleBlurAllDropdowns();
                              }}
                              label={errorsFiltersPurchaseDelivery.ori_tras_store_idTo != null ? t(errorsFiltersPurchaseDelivery.ori_tras_store_idTo) : t("Text_Filter_TradeName_To")}
                              placeholder={t("PlaceHolder_Filter_tradename_to")}
                              inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                              variant="outlined"
                            />
                            <Dropdown
                              filtered={storeToAC.filtered}
                              highlight={storeToAC.highlight}
                              onPick={(s) => storeToAC.onKeyDown({ key: "Enter" })}
                              renderItem={(s) => `${s.documentid} - ${s.tradename}`}
                            />
                          </span>
                        </div>

                        {/* WORKPLACE FROM/TO */}
                        <div className="form-group">
                          <span style={{ position: "relative" }}>
                            <TextField
                              id="ori_tras_workplaceFrom"
                              name="ori_tras_workplaceFrom"
                              value={filterPurchase.ori_tras_workplaceFrom}
                              onChange={(e) => {
                                const v = safeUpper(e.target.value);
                                setFilterPurchase((p) => ({ ...p, ori_tras_workplaceFrom: v, ori_tras_workplaceTo: v }));
                                wpFromAC.debouncedSearch(v);
                              }}
                              onKeyDown={wpFromAC.onKeyDown}
                              onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) handleBlurAllDropdowns();
                              }}
                              label={errorsFiltersPurchaseDelivery.ori_tras_workplaceFrom != null ? t(errorsFiltersPurchaseDelivery.ori_tras_workplaceFrom) : t("Text_Filter_WorkPlace_From")}
                              placeholder={t("PlaceHolder_Filter_WorkPlace_From")}
                              inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                              variant="outlined"
                            />
                            <Dropdown filtered={wpFromAC.filtered} highlight={wpFromAC.highlight} onPick={(s) => wpFromAC.onKeyDown({ key: "Enter" })} renderItem={(s) => `${s.workplace}`} />
                          </span>

                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                          <span style={{ position: "relative" }}>
                            <TextField
                              id="ori_tras_workplaceTo"
                              name="ori_tras_workplaceTo"
                              value={filterPurchase.ori_tras_workplaceTo}
                              onChange={(e) => {
                                const v = safeUpper(e.target.value);
                                setFilterPurchase((p) => ({ ...p, ori_tras_workplaceTo: v }));
                                wpToAC.debouncedSearch(v);
                              }}
                              onKeyDown={wpToAC.onKeyDown}
                              onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) handleBlurAllDropdowns();
                              }}
                              label={errorsFiltersPurchaseDelivery.ori_tras_workplaceTo != null ? t(errorsFiltersPurchaseDelivery.ori_tras_workplaceTo) : t("Text_Filter_WorkPlace_To")}
                              placeholder={t("PlaceHolder_Filter_WorkPlace_To")}
                              inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                              variant="outlined"
                            />
                            <Dropdown filtered={wpToAC.filtered} highlight={wpToAC.highlight} onPick={(s) => wpToAC.onKeyDown({ key: "Enter" })} renderItem={(s) => `${s.workplace}`} />
                          </span>
                        </div>

                        {/* TRANSPORTER FROM/TO */}
                        <div className="form-group">
                          <span style={{ position: "relative" }}>
                            <TextField
                              id="rel_trans_store_idFrom"
                              name="rel_trans_store_idFrom"
                              value={filterPurchase.rel_trans_store_idFrom}
                              onChange={(e) => {
                                const v = safeUpper(e.target.value);
                                setFilterPurchase((p) => ({ ...p, rel_trans_store_idFrom: v, rel_trans_store_idTo: v }));
                                transFromAC.debouncedSearch(v);
                              }}
                              onKeyDown={transFromAC.onKeyDown}
                              onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) handleBlurAllDropdowns();
                              }}
                              label={errorsFiltersPurchaseDelivery.rel_trans_store_idFrom != null ? t(errorsFiltersPurchaseDelivery.rel_trans_store_idFrom) : t("Text_Filter_Trans_From")}
                              placeholder={t("PlaceHolder_Filter_Trans_From")}
                              inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                              variant="outlined"
                            />
                            <Dropdown filtered={transFromAC.filtered} highlight={transFromAC.highlight} onPick={(s) => transFromAC.onKeyDown({ key: "Enter" })} renderItem={(s) => `${s.documentid} - ${s.tradename}`} />
                          </span>

                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                          <span style={{ position: "relative" }}>
                            <TextField
                              id="rel_trans_store_idTo"
                              name="rel_trans_store_idTo"
                              value={filterPurchase.rel_trans_store_idTo}
                              onChange={(e) => {
                                const v = safeUpper(e.target.value);
                                setFilterPurchase((p) => ({ ...p, rel_trans_store_idTo: v }));
                                transToAC.debouncedSearch(v);
                              }}
                              onKeyDown={transToAC.onKeyDown}
                              onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) handleBlurAllDropdowns();
                              }}
                              label={errorsFiltersPurchaseDelivery.rel_trans_store_idTo != null ? t(errorsFiltersPurchaseDelivery.rel_trans_store_idTo) : t("Text_Filter_Trans_To")}
                              placeholder={t("PlaceHolder_Filter_Trans_To")}
                              inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                              variant="outlined"
                            />
                            <Dropdown filtered={transToAC.filtered} highlight={transToAC.highlight} onPick={(s) => transToAC.onKeyDown({ key: "Enter" })} renderItem={(s) => `${s.documentid} - ${s.tradename}`} />
                          </span>
                        </div>

                        {/* VEHICLE FROM/TO */}
                        <div className="form-group">
                          <span style={{ position: "relative" }}>
                            <TextField
                              id="vehiclestore_licenseplateFrom"
                              name="vehiclestore_licenseplateFrom"
                              value={filterPurchase.vehiclestore_licenseplateFrom}
                              onChange={(e) => {
                                const v = safeUpper(e.target.value);
                                setFilterPurchase((p) => ({ ...p, vehiclestore_licenseplateFrom: v, vehiclestore_licenseplateTo: v }));
                                vehFromAC.debouncedSearch(v);
                              }}
                              onKeyDown={vehFromAC.onKeyDown}
                              onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) handleBlurAllDropdowns();
                              }}
                              label={errorsFiltersPurchaseDelivery.vehiclestore_licenseplateFrom != null ? t(errorsFiltersPurchaseDelivery.vehiclestore_licenseplateFrom) : t("Text_Filter_LicensePlate_From")}
                              placeholder={t("PlaceHolder_Filter_LicensePlate_From")}
                              inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                              variant="outlined"
                            />
                            <Dropdown filtered={vehFromAC.filtered} highlight={vehFromAC.highlight} onPick={(s) => vehFromAC.onKeyDown({ key: "Enter" })} renderItem={(v) => `${v.licenseplate}`} />
                          </span>

                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                          <span style={{ position: "relative" }}>
                            <TextField
                              id="vehiclestore_licenseplateTo"
                              name="vehiclestore_licenseplateTo"
                              value={filterPurchase.vehiclestore_licenseplateTo}
                              onChange={(e) => {
                                const v = safeUpper(e.target.value);
                                setFilterPurchase((p) => ({ ...p, vehiclestore_licenseplateTo: v }));
                                vehToAC.debouncedSearch(v);
                              }}
                              onKeyDown={vehToAC.onKeyDown}
                              onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) handleBlurAllDropdowns();
                              }}
                              label={errorsFiltersPurchaseDelivery.vehiclestore_licenseplateTo != null ? t(errorsFiltersPurchaseDelivery.vehiclestore_licenseplateTo) : t("Text_Filter_LicensePlate_To")}
                              placeholder={t("PlaceHolder_Filter_LicensePlate_To")}
                              inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                              variant="outlined"
                            />
                            <Dropdown filtered={vehToAC.filtered} highlight={vehToAC.highlight} onPick={(s) => vehToAC.onKeyDown({ key: "Enter" })} renderItem={(v) => `${v.licenseplate}`} />
                          </span>
                        </div>

                        {/* AMOUNT FROM/TO */}
                        <div className="form-group">
                          <NumericFormat
                            thousandSeparator={""}
                            decimalSeparator={"."}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            allowNegative={false}
                            isAllowed={withValueCap}
                            id="amountFROM"
                            name="amountFROM"
                            value={filterPurchase.amountFROM}
                            label={errorsFiltersPurchaseDelivery.amountFROM != null ? t(errorsFiltersPurchaseDelivery.amountFROM) : t("Text_Filter_amount_From")}
                            placeholder={t("PlaceHolderFilter_amount_From")}
                            inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 20 }}
                            InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                            customInput={TextField}
                            onBlur={(e) => handleBlurAmountFrom(e.target.value)}
                            onChange={(e) => handleChangeAmountFrom(e.target.value)}
                          />
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <NumericFormat
                            thousandSeparator={""}
                            decimalSeparator={"."}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            allowNegative={false}
                            isAllowed={withValueCap}
                            id="amountTO"
                            name="amountTO"
                            value={filterPurchase.amountTO}
                            label={errorsFiltersPurchaseDelivery.amountTO != null ? t(errorsFiltersPurchaseDelivery.amountTO) : t("Text_Filter_amount_To")}
                            placeholder={t("PlaceHolder_Filter_amount_To")}
                            inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 20 }}
                            InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                            customInput={TextField}
                            onBlur={(e) => handleBlurAmountTo(e.target.value)}
                            onChange={(e) => handleChangeAmountTo(e.target.value)}
                          />
                        </div>

                        {/* PAYMENT FROM/TO */}
                        <div className="form-group">
                          <TextField
                            id={i18n.language === "es" ? "paymentFromES" : "paymentFromEN"}
                            name={i18n.language === "es" ? "paymentFromES" : "paymentFromEN"}
                            value={i18n.language === "es" ? filterPurchase.paymentFromES : filterPurchase.paymentFromEN}
                            inputProps={{ style: { width: 382, fontSize: "18px" }, maxLength: 100 }}
                            InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                            label={t("Text_Filter_payment_From")}
                            placeholder={t("PlaceHolder_Filter_payment_From")}
                            variant="outlined"
                            onBlur={handleBlurFilterEditPurchaseDelivery}
                            onChange={handleChangeFilterEditPurchaseDelivery}
                            select
                            SelectProps={{ native: true }}
                          >
                            <option key={0} value="" />
                            {paymenetTypeSelect.map((opt) => (
                              <option key={opt.id} value={i18n.language === "es" ? opt.namees : opt.nameen}>
                                {i18n.language === "es" ? opt.namees : opt.nameen}
                              </option>
                            ))}
                          </TextField>

                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                          <TextField
                            id={i18n.language === "es" ? "paymentToES" : "paymentToEN"}
                            name={i18n.language === "es" ? "paymentToES" : "paymentToEN"}
                            value={i18n.language === "es" ? filterPurchase.paymentToES : filterPurchase.paymentToEN}
                            inputProps={{ style: { width: 382, fontSize: "18px" }, maxLength: 100 }}
                            InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                            label={t("Text_Filter_payment_To")}
                            placeholder={t("PlaceHolder_Filter_payment_To")}
                            variant="outlined"
                            onBlur={handleBlurFilterEditPurchaseDelivery}
                            onChange={handleChangeFilterEditPurchaseDelivery}
                            select
                            SelectProps={{ native: true }}
                          >
                            <option key={0} value="" />
                            {paymenetTypeSelect
                              .filter((item) => (i18n.language === "es" ? item.namees >= filterPurchase.paymentFromES : item.nameen >= filterPurchase.paymentFromEN))
                              .map((opt) => (
                                <option key={opt.id} value={i18n.language === "es" ? opt.namees : opt.nameen}>
                                  {i18n.language === "es" ? opt.namees : opt.nameen}
                                </option>
                              ))}
                          </TextField>
                        </div>
                      </div>

                      <hr className="sidebar-divider d-none d-md-block" />

                      <div className="formdi-pending-action-group">
                        <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button" onClick={handleSubmitFilterEditPurchaseDelivery}>
                          {t("Button_Apply")}
                        </button>
                        <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFiltersPurchaseDelivery}>
                          {t("Button_Cancel_Filters")}
                        </button>
                      </div>
                    </form>
                  </Box>
                </Container>
              </SwipeableDrawer>
            )}
            <PurchaseDeliveryPDF key={rowEditPurchaseDelivery.id} rowEditPurchaseDelivery={rowEditPurchaseDelivery} viewPDF={viewPDF} setViewPDF={setViewPDF} />
            <PurchaseFormDI openViewFormDI={openViewFormDI} setOpenViewFormDI={setOpenViewFormDI} rowEditPurchaseDelivery={rowEditPurchaseDelivery} />
            {/* Dialog Delete */}
            <Dialog open={openDeleteRowPurchaseDelivery} onClose={handleCancelDeleteRowPurchaseDelivery} PaperProps={{ className: "my-dialog-paper-danger" }}>
              <DialogTitle className="my-dialog-title-danger">
                {t("Text_Delete")} {rowEditPurchaseDelivery.purchasenote} - {rowEditPurchaseDelivery.ori_tras_tradename}
              </DialogTitle>
              <DialogContent>
                <DialogContentText className="my-dialog-contentText-danger">
                  {t("Text_Line1")}
                  <br />
                  {t("Text_Line2")}
                </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="idCode"
                  label={t("Text_Label")}
                  type="text"
                  fullWidth
                  variant="standard"
                  className="my-dialog-input-danger"
                  defaultValue={idCodeDelete}
                  onChange={handleChangeDeleteRowPurchaseDelivery}
                />
              </DialogContent>
              <DialogActions className="my-dialog-actions">
                <Button onClick={handleCancelDeleteRowPurchaseDelivery} className="my-dialog-button-cancel-danger">
                  {t("Button_Cancel")}
                </Button>
                <Button variant="contained" onClick={handleCloseDeleteRowPurchaseDelivery} className="my-dialog-button-delete">
                  {t("Button_Delete")}
                </Button>
              </DialogActions>
            </Dialog>

            {/* Dialog Enable/Disable */}
            <Dialog open={openEnabledRowPurchaseDelivery} onClose={handleCancelEnabledRowPurchaseDelivery} PaperProps={{ className: "my-dialog-paper-danger" }}>
              <DialogTitle className="my-dialog-title-danger">
                {rowEditPurchaseDelivery.enabled ? t("Text_Disabled") : t("Text_Enabled")} {rowEditPurchaseDelivery.purchasenote} - {rowEditPurchaseDelivery.ori_tras_tradename}
              </DialogTitle>
              <DialogContent>
                <DialogContentText className="my-dialog-contentText-danger">
                  {t("Text_Line7")}&nbsp;{t("Text_Line8")}
                </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="idCode"
                  label={t("Text_Label")}
                  type="text"
                  fullWidth
                  variant="standard"
                  className="my-dialog-input-danger"
                  defaultValue={idCodeDelete}
                  onChange={handleChangeEnableRowPurchaseDelivery}
                />
              </DialogContent>
              <DialogActions className="my-dialog-actions">
                <Button onClick={handleCancelEnabledRowPurchaseDelivery} className="my-dialog-button-cancel-danger">
                  {t("Button_Cancel")}
                </Button>
                <Button variant="contained" onClick={handleCloseEnabledRowPurchaseDelivery} className="my-dialog-button-delete">
                  {t("Button_ENABLED")}
                </Button>
              </DialogActions>
            </Dialog>

            {/* Dialog Return/Finish */}
            <Dialog open={openReturnRowPurchaseDelivery} onClose={handleCancelReturnRowPurchaseDelivery} PaperProps={{ className: "my-dialog-blue-paper" }}>
              <DialogTitle className="my-dialog-blue-title">{!endedFlag ? t("Button_Finish") : t("Button_Pending")}</DialogTitle>
              <DialogContent>
                <DialogContentText className="my-dialog-blue-contentText">{t("Text_Line9")}</DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="idCode"
                  label={t("Text_Label_Confirma")}
                  type="text"
                  fullWidth
                  variant="standard"
                  className="my-dialog-blue-input"
                  placeholder={CONFIRM_CODE}
                  defaultValue={idCodeReturn || ""}
                  onChange={handleChangeEnableReturnRowPurchaseDelivery}
                />
              </DialogContent>
              <DialogActions className="my-dialog-blue-actions">
                <Button onClick={handleCancelReturnRowPurchaseDelivery} className="my-dialog-blue-button-cancel">
                  {t("Button_Cancel")}
                </Button>
                <Button variant="contained" onClick={handleFinishSelectedPurchaseDelivery} className="my-dialog-blue-button-copy">
                  {t("Button_CONFiRM")}
                </Button>
              </DialogActions>
            </Dialog>

            {/* Dialog Create Blank */}
            <Dialog open={openCreateBlankPurchaseDelivery} onClose={() => setOpenCreateBlankPurchaseDelivery(false)} PaperProps={{ className: "my-dialog-paper" }}>
              <DialogTitle className="my-dialog-title">{t("Text_Copy")}</DialogTitle>
              <DialogContent>
                <DialogContentText className="my-dialog-contentText">{t("Text_Line1_Copy")}</DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="numberCopy"
                  label={t("Text_Label_Copy")}
                  type="number"
                  inputProps={{ min: 1, step: 1 }}
                  fullWidth
                  variant="standard"
                  className="my-dialog-input"
                  defaultValue={numberCopy || 1}
                  onChange={handleChangeCopyFormDI}
                />
              </DialogContent>
              <DialogActions className="my-dialog-actions">
                <Button onClick={() => setOpenCreateBlankPurchaseDelivery(false)} className="my-dialog-button-cancel">
                  {t("Button_Cancel")}
                </Button>
                <Button variant="contained" onClick={handleSubmitCreateBlankPurchaseDelivery} className="my-dialog-button-copy">
                  {t("Button_Copy")}
                </Button>
              </DialogActions>
            </Dialog>
          </>
        ) : (
          <LoadingNews />
        )}
      </div>
    </>
  );
};

PurchaseDeliveryFilter.propTypes = {
  showModalPurchasesDeliverySettings: PropTypes.bool.isRequired,
  setShowModalPurchasesDeliverySettings: PropTypes.func.isRequired,
  typeOfList: PropTypes.string.isRequired,
};

export default PurchaseDeliveryFilter;